import React from 'react';
import { HotelType } from '../../../backend/src/shared/types';

interface WhyThisResortProps {
  hotel: HotelType;
}

const WhyThisResort: React.FC<WhyThisResortProps> = ({ hotel }) => {
  const hotelPoints = hotel.dealHighlights;

  if (!hotelPoints) {
    return null;
  }

  return (
    <div className='container p-6 shadow-lg rounded-lg bg-white mx-auto border-t-4 border-halo-pink flex flex-col items-center min-h-[300px]'>
      <hr className="w-full mb-4 border-gray-300" />
      <div className='flex items-center justify-center gap-2 mb-4'>
        <img src='/featureIcons/high2.svg' alt='highlights' className='w-7 h-7' />
        <h2 className="text-2xl font-bold text-center">Deal Highlights</h2>
      </div>
      <hr className="w-full mb-6" />

      <div className="space-y-4 w-full">
        {hotel.dealHighlights.map((point, index) => (
          <div key={index} className="flex items-start">
            <ul className="space-y-2 text-sm ml-4 text-gray-700 sitemap-bullet">
              <li>{typeof point === 'string' ? point : point.value}</li>
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyThisResort;

export const hasWhyThisResort = (hotel: HotelType) => {
  return Array.isArray(hotel.dealHighlights) && hotel.dealHighlights.length > 0;
};